import { render, staticRenderFns } from "./DoctorDashboard.vue?vue&type=template&id=105f8be2&scoped=true&"
import script from "./DoctorDashboard.vue?vue&type=script&lang=js&"
export * from "./DoctorDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f8be2",
  null
  
)

export default component.exports